export type TelephonyProvider = 'RINGCENTRAL' | 'VICIDIAL'

export interface TelephonyDrawerDiagnostics {
  message?: string
  agent_user?: string
  status?: string
  campaign_id?: string
  session_id?: string
  phone_number?: string
  raw_response?: string
}

export interface TelephonyResolveResponse {
  provider: TelephonyProvider
  telephony_provider: TelephonyProvider
  source: string
  vicidial_enabled: boolean
  vicidial_base_url: string
  vicidial_agent_user: string
  vicidial_phone_login: string
  vicidial_auto_login_configured: boolean
  vicidial_webphone_configured: boolean
  ringcentral_enabled: boolean
}

export interface TelephonyWebphoneResponse {
  provider: TelephonyProvider
  url: string
  source: 'api' | 'config' | 'autologin'
  display_mode?: 'webphone' | 'agent'
  warning?: string
  opened_externally?: boolean
}

export interface TelephonyStartResponse {
  provider: TelephonyProvider
  call_id?: number | null
  lead_id?: number | null
  agent_user?: string
  normalized_phone?: string
  raw_response?: string
  external_call_id?: string
  session_status?: {
    status?: string
    campaign_id?: string
    session_id?: string
    phone_number?: string
  }
  session_raw_response?: string
}

export interface TelephonyStatusResponse {
  provider: TelephonyProvider
  agent_user?: string
  active_session: boolean
  raw_response?: string
  status?: string
  call_id?: string
  lead_id?: string
  campaign_id?: string
  real_time_sub_status?: string
  phone_number?: string
  vendor_lead_code?: string
  session_id?: string
}

export interface TelephonyDisconnectResponse {
  provider: TelephonyProvider
  agent_user?: string
  raw_response?: string
  hangup_raw_response?: string
  active_session: boolean
  status?: string
  campaign_id?: string
  session_id?: string
  phone_number?: string
  status_before_disconnect?: string
}

export interface TelephonyDrawerOpenDetail {
  url: string
  provider?: TelephonyProvider
  title?: string
  warning?: string
  width?: string
  diagnostics?: TelephonyDrawerDiagnostics
}

export const TELEPHONY_DRAWER_OPEN_EVENT = 'telephony:open-drawer'
export const TELEPHONY_DRAWER_UPDATE_EVENT = 'telephony:update-drawer'
export const TELEPHONY_DRAWER_CLOSE_EVENT = 'telephony:close-drawer'
export const TELEPHONY_VICIDIAL_LOGOUT_EVENT = 'telephony:vicidial-logout'
